export default __webpack_public_path__ + "static/media/rent-second-img3.2b6ac102.jpg";